import { DateTime } from "luxon";

export const dayMMDDYYYY = (date: DateTime) => {
  return date.toFormat("ccc MM-dd-yyyy").toUpperCase();
};
